import Icon from '../components/Icon.vue'

Icon.register({"inbox":{"width":1536,"height":1792,"paths":[{"d":"M1023 960h316q-1-3-2.5-8.5t-2.5-7.5l-212-496h-708l-212 496q-1 3-2.5 8.5t-2.5 7.5h316l95 192h320zM1536 990v482q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-482q0-62 25-123l238-552q10-25 36.5-42t52.5-17h832q26 0 52.5 17t36.5 42l238 552q25 61 25 123z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/inbox.js
// module id = 79tH
// module chunks = 1